export default {
  current_action: '',
}
